import { ArrowDown, ArrowUp, ChevronDown, ChevronUp } from 'lucide-react';
import React, { useState } from 'react';

const SelectBox = ({ label = "Category", options = [], onSelect, ...other }) => {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState('All');

  const handleSelect = (option) => {
    setSelected(option.label);
    setOpen(false);
    if (onSelect) onSelect(option);
  };

  return (
    <div className="select-box" {...other}>
      <div className="select-label" style={other.style || {}} onClick={() => setOpen(!open)}>
        {label}: <span className="selected">{selected}</span>
        <span className="arrow">{open ? <ChevronUp /> : <ChevronDown />}</span>
      </div>
      {open && (
        <ul className="options">
          {options.map((opt, i) => (
            <li key={i} onClick={() => handleSelect(opt)}>
              {opt.label}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SelectBox;
